module.exports = __webpack_public_path__ + "images/Configurations_spaces.jpg?v=c88269dd89b4e58b0dfba3990f101a4c";